import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DatePicker, DateRangeInputs } from "@libs/rubick";
import { USAGE_VIEW_TYPES } from "@/constants/usage";
import { formatDateInput, parseDateInput } from "@/utils/date";
export const DateRangeSelector = ({ filters, onDateChange, onDateRangeChange })=>{
    const handleSingleDateChange = (date)=>{
        onDateChange(date ? formatDateInput(date) : "");
    };
    const handleStartDateChange = (date)=>{
        onDateRangeChange(date ? formatDateInput(date) : "", filters.endDate);
    };
    const handleEndDateChange = (date)=>{
        onDateRangeChange(filters.startDate, date ? formatDateInput(date) : "");
    };
    if (filters.viewType === USAGE_VIEW_TYPES.HOURLY) {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("label", {
                    htmlFor: "date",
                    className: "block text-sm font-medium text-gray-700 mb-2",
                    children: "Date"
                }),
                /*#__PURE__*/ _jsx(DatePicker, {
                    date: parseDateInput(filters.selectedDate),
                    onDateChange: handleSingleDateChange,
                    placeholder: "Pick a date"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("label", {
                className: "block text-sm font-medium text-gray-700 mb-2",
                children: "Date Range"
            }),
            /*#__PURE__*/ _jsx(DateRangeInputs, {
                startDate: parseDateInput(filters.startDate),
                endDate: parseDateInput(filters.endDate),
                onStartDateChange: handleStartDateChange,
                onEndDateChange: handleEndDateChange,
                startPlaceholder: "Start date",
                endPlaceholder: "End date"
            })
        ]
    });
};
